import { NavigationContainer } from "@react-navigation/native";
import { Currency } from "currency";
import { useLocalSearchParams, useNavigation } from "expo-router";
import { MerchantPricing, ProductForm, ProductFormParams } from "ui/merchant";

import useAPI, { APIProvider } from "@/src/contexts/api-context";

export default function Wrapper() {
  const { uuid, currency, userId } = useLocalSearchParams<{
    uuid: string;
    currency?: string;
    userId?: string;
  }>();

  const isNew = uuid === "new";

  if (!isNew) {
    if (!userId) throw new Error("Missing userId");
    if (isNaN(Number(userId))) throw new Error("Invalid userId");
  }

  return (
    <APIProvider
      baseURL="https://examples.cuanto.app"
      userId={isNew ? 1 : Number(userId)}
    >
      <Form
        currency={currency === "crc" ? "crc" : "usd"}
        uuid={isNew ? undefined : uuid}
      />
    </APIProvider>
  );
}

type Props = {
  currency: Currency;
  uuid?: string;
};

function Form({ currency, uuid }: Props) {
  const { apiClient } = useAPI();
  const { goBack } = useNavigation();

  async function fetchProduct(uuid: string): Promise<ProductFormParams> {
    const { data } = await apiClient.get<ProductFormParams>(
      `/products/${uuid}?include_variants=true`
    );
    return data;
  }

  async function onCreateProduct(params: ProductFormParams) {
    console.log("create", params);
  }
  async function onUpdateProduct(uuid: string, params: ProductFormParams) {
    console.log("update", uuid, params);
  }

  async function uploadImageToStorage(base64: string) {
    console.log(base64);
    // TODO:
    return {
      imageUrl:
        "https://cuanto-products.nyc3.digitaloceanspaces.com/618d4d69-f539-44c1-b56e-84c2ae94a18e",
    };
  }
  async function deleteImageFromStorage(url: string) {
    console.log("DELETE", url);
  }
  async function deleteProduct() {
    console.log("DELETE PRODUCT");
  }

  async function getPricing() {
    const { data } = await apiClient.get<MerchantPricing>("/merchant/pricing");
    return data;
  }

  return (
    <NavigationContainer>
      <ProductForm
        username="r"
        getPricing={getPricing}
        productUuid={uuid}
        isCloningProduct={false}
        fetchProduct={fetchProduct}
        onCreateProduct={onCreateProduct}
        onUpdateProduct={onUpdateProduct}
        deleteProduct={deleteProduct}
        goBack={goBack}
        uploadImageToStorage={uploadImageToStorage}
        deleteImageFromStorage={deleteImageFromStorage}
        onAskForHelp={console.log}
      />
    </NavigationContainer>
  );
}
